module.exports = __webpack_public_path__ + "static/img/distribution_system3.a1111e27.jpg";